import { AgentCode } from '@/data/enums/agentCode';
import { Product } from '@/data/enums/product';
import { useRoute } from '@/data/hooks';

export const useAgentCode = () => {
  const { product } = useRoute();

  return {
    [Product.EasyHealth]: AgentCode.EasyHealth,
    [Product.EzyMedical]: AgentCode.EzyMedical,
    [Product.iMedicalCard]: AgentCode.iMedicalCard,
  }[product];
};
